import { StateUtils } from '@spartacus/core';
import { AreaOfUse } from '../../../core/model';

export const AREA_OF_USE_ADMIN_FEATURE = 'areaOfUseAdmin';

export const AREA_OF_USE_CATEGORY_ADMIN = '[AreaOfUseAdmin] Area of Use category admin';
export const AREA_OF_USE_LIST_ADMIN = '[AreaOfUseAdmin] Area of Use list admin';
export const AREAS_OF_USE_PUBLISH_ADMIN = '[AreaOfUseAdmin] Areas of Use publish admin';
export const AREA_OF_USE_PRODUCTS = '[AreaOfUseAdmin] Area of Use products';
export const AREA_OF_USE_PRODUCTS_ADD = '[AreaOfUseAdmin] Add product to area of use';
export const AREA_OF_USE_EXCLUDE_ARTICLES = '[AreaOfUseAdmin] Exclude articles from area of use';
export const AREA_OF_USE_PRODUCTS_REMOVE = '[AreaOfUseAdmin] Remove product from area of use';
export const AREA_OF_USE_PRODUCTS_REPLACE = '[AreaOfUseAdmin] Replace product from area of use';
export const AREA_OF_USE_CATEGORY_DETAILS = '[AreaOfUseAdmin] Load details for area of use';

export const CREATE_AREA_OF_USE_CATEGORY_PROCESS = 'createAreaOfUseCategory';

export interface StateWithAreaOfUseAdmin {
  [AREA_OF_USE_ADMIN_FEATURE]: AreaOfUseAdminState;
}

export interface AreaOfUseAdminState {
  categories: StateUtils.EntityLoaderState<AreaOfUse>;
  details: StateUtils.LoaderState<AreaOfUse>;
  list: StateUtils.LoaderState<AreaOfUseAdminListState>;
  publish: StateUtils.LoaderState<string>;
  products: AreaOfUseProductsState;
}

export interface AreaOfUseAdminListState {
  lastUpdateTime: string;
  results?: string[]; // Arrays of area of use codes
}

export interface AreaOfUseProductsState {
  list: StateUtils.LoaderState<AreaOfUse[]>;
  add: StateUtils.LoaderState<AreaOfUse>;
  remove: StateUtils.LoaderState<AreaOfUse>;
  replace: StateUtils.LoaderState<AreaOfUse>;
}
